/**
 * The "unit created" message with an Open button (ISS-655): after a fast-save create the
 * form is already closed, so the way into the new unit is this message, not a redirect
 * that would pull someone away from what they started doing.
 *
 * @module components/Equipment/GeneratorCreatedToast
 */
interface GeneratorCreatedToastProps {
  readonly message: string;
  readonly onOpen: () => void;
}

export function GeneratorCreatedToast({ message, onOpen }: GeneratorCreatedToastProps) {
  return (
    <span className="flex items-center gap-3">
      <span>{message}</span>
      <button
        type="button"
        onClick={onOpen}
        className="rounded-lg bg-white/15 px-2 py-1 text-sm font-medium text-white ring-1 ring-white/70 hover:bg-white/25"
      >
        Open
      </button>
    </span>
  );
}
